import * as React from 'react';
import { Input } from '@ui/components';

import './InputLogin.less';

interface Props {
  onChange: (name: string, value: string) => void;
  value: string;
  name: string;
  type: string;
  prefix: React.ReactNode;
  placeholder: string;
}

class InputLogin extends React.PureComponent<Props> {
  static defaultProps = {
    type: '',
    placeholder: '',
  };

  render() {
    const { value, onChange, name, type, prefix, placeholder } = this.props;
    return (
      <div className="login-form-field">
        <Input
          className="login-form-field__input"
          value={value}
          onChange={onChange}
          name={name}
          type={type}
          size={'large'}
          prefix={prefix}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default InputLogin;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/InputLogin/InputLogin.tsx